<template>
	<div class="index-container" style="display: flex;flex-direction: column;align-items: center;">
		<div v-for="(item,i) in tableData" :key="i"
			style="height: 400px; width: 60vw; box-shadow:1px 1px 10px #ccc;overflow-y: scroll; margin-top: 45px; padding: 15px;">
			<h3 style="text-align: center;">{{item.title}}</h3>
			<span style="font-size: 14px; color: #999999;">{{item.update_time}}</span>
			<div v-html="item.content"></div>
		</div>
		<el-pagination background layout="prev, pager, next" :total="total" style="margin-top: 40px;" @current-change="changePage">
		</el-pagination>
	</div>
</template>

<script>
	import {
		contents
	} from '../../api/content.js'
	import mixins from '../../mixins.js'
	export default {
		mixins: [mixins],
		data() {
			return {
			}
		},
		methods: {
			async getData() {
				let res = (await contents(this.queryParams)).data
				this.tableData = res.data
				this.total = res.count
			}
		}
	}
</script>

<style>
</style>
